import React, { useState } from "react";
import { Check, Lock, CreditCard, Zap } from "lucide-react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import professional_tab from "../../../assets/img/professional_tab.svg";
import client_tab from "../../../assets/img/client_tab.svg";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import CasesOutlinedIcon from "@mui/icons-material/CasesOutlined";
import Overlay_tick from "../../../assets/img/Overlay_tick.svg";
import pricing_icon_profile from "../../../assets/img/pricing_icon_profile.svg";
import Plan from "../../../assets/img/Pro Plan.svg";
import Annual from "../../../assets/img/Pro Plan Annual.svg";
import BiddingCosts from "../../../assets/img/Bidding Costs.svg";
import Credit from "../../../assets/img/Credit Pricing.svg";
import Earn from "../../../assets/img/Earn Free Credits.svg";
import ExpertSupport from "../../../assets/img/Expert Support.svg";
import VerifiedClients from "../../../assets/img/Verified Clients.svg";
import GrowYourBusiness from "../../../assets/img/Grow Your Business.svg";
import WELCOME_TO_SIMPLERENOVATE from "../../../assets/img/WELCOME TO SIMPLERENOVATE.svg";
import For_Professionals from "../../../assets/img/For Professionals.svg";
import For_Professionals1 from "../../../assets/img/For Professionals1.svg";
import For_Clients from "../../../assets/img/For Clients.svg";
import For_Clients1 from "../../../assets/img/For Clients1.svg";
import Buy_Credits from "../../../assets/img/Buy Credits.svg";
import first_time_rewards from "../../../assets/img/first time rewards.svg";
import ongoing_reward from "../../../assets/img/ongoing reward.svg";
import pricing1 from "../../../assets/img/pricing 1.svg";
import pricing2 from "../../../assets/img/pricing 2.svg";
import pricing3 from "../../../assets/img/pricing 3.svg";
import pricing4 from "../../../assets/img/pricing 4.svg";
import pricing5 from "../../../assets/img/pricing 5.svg";
import pricing6 from "../../../assets/img/pricing 6.svg";
import pricing7 from "../../../assets/img/pricing 7.svg";
import pricing8 from "../../../assets/img/pricing 8.svg";
import pricing9 from "../../../assets/img/pricing 9.svg";
import activeIcon from "../../../assets/img/active pricing icon.svg";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";
import {stripeKey,monthlyPlanPriceId} from "../../../Utils/Constants";

const Pricing = () => {
  const [active, setActive] = useState(1);
  const [settingData, setSettingData] = useState({});
  const [ongoingRewards, setOngoingRewards] = useState([]);
  const [everFreeRewards, setEarnFreeRewards] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const stripePromise = loadStripe(
    stripeKey
  );


  const biddingCosts = [
    {
      name: "Standard Client",
      description: "Basic job postings",
      credits: 10,
      className: "",
    },
    {
      name: "Premium Client",
      description: "Ready-to-go",
      credits: 40,
      className: "premium-card",
    },
  ];

  useEffect(() => {
    dispatch(hitGetSettingsApi()).then((response) => {
      if (response.payload && response.payload.status === true) {
        setSettingData(response.payload.data);

        setOngoingRewards([
          {
            name: "Every 10 bids submitted",
            credits: response.payload.data.professionalEveryTenBidsPoints,
          },

          {
            name: "Complete a job",
            credits: response.payload.data.professionalCompleteJobPoints,
          },

          // {
          //   name: "Refer a contractor",
          //   credits: response.payload.data.refererOtherContractor,
          // },
        ]);

        setEarnFreeRewards([
          {
            name: "Verify your business",
            credits: response.payload.data.professionalVerifyBusinessPoints,
          },
          {
            name: "Submit your first bid",
            credits: response.payload.data.professionalSubmitFirstBidPoints,
          },
          {
            name: "Post your first promotion",
            credits: response.payload.data.professionalPostFirstPromotionPoints,
          },
          {
            name: "Verify your license",
            credits: response.payload.data.professionalVerifyLicensePoints,
          },
          {
            name: "Import reviews",
            credits: response.payload.data.professionalImportReviewsPoints,
          },
          {
            name: "Complete your first job",
            credits: response.payload.data.professionalCompleteFirstJobPoints,
          },
          {
            name: "Refer your first contractor",
            credits: response.payload.data.refererFirstContractor,
          },
        ]);
      }
    });
  }, [dispatch]);

  const pricingTiers = [
    { credits: 10, price: "$10.00" },
    { credits: 25, price: "$23.75" },
    { credits: 50, price: "$45.00" },
    { credits: 100, price: "$90.00" },
  ];

  const policyItems = [
    "Credits expire 1 year after purchase",
    "Credits expire after 12 months of inactivity (no Pro subscription, logins, or bids)",
    "Pro members get bid credit protection - credits refunded if job is deleted",
    "All credits are non-refundable",
  ];

  const features = [
    {
      icon: <img src={pricing1} alt="Pricing 1" />,
      title: "100 Credits Per Month",
      description: "Use for bids, boosts, and much more.",
    },
    {
      icon: <img src={pricing2} alt="Pricing 2" />,
      title: "Top-Listed Pro Visibility",
      description: "Appear as a recommended professional in client searches.",
    },
    {
      icon: <img src={pricing3} alt="Pricing 3" />,
      title: "Exclusive Promotions",
      description: "Direct, non-competitive bids sent to you.",
    },
    {
      icon: <img src={pricing4} alt="Pricing 4" />,
      title: "Import Reviews",
      description: "Import your Google business reviews.",
    },
    {
      icon: <img src={pricing5} alt="Pricing 5" />,
      title: "Full Client Insights",
      description: "View past jobs, budget ranges, and total spends.",
    },
    {
      icon: <img src={pricing6} alt="Pricing 6" />,
      title: "Bid credit protection",
      description: "Credits refunded if the job posting is removed.",
    },
    {
      icon: <img src={pricing9} alt="Pricing 6" />,
      title: "See the number of bids on each job",
      description: "Track how many professionals have bid on each job.",
    },
    {
      icon: <img src={pricing7} alt="Pricing 7" />,
      title: "Ready-to-Go (RTG) Job Access",
      description: "Bid on high-intent clients ready to hire immediately.",
    },
    {
      icon: <img src={pricing8} alt="Pricing 7" />,
      title: "Good-Better-Best (GBB) Bid Options",
      description:
        "Offer tiered estimates for clearer, higher-converting proposals.",
    },
  ];

  return (
    <div className="pricing-container">
      <div className="custom_container">
        <div className="plan-header">
          <p className="welcome">
            <span>
              <img
                src={WELCOME_TO_SIMPLERENOVATE}
                alt="WELCOME_TO_SIMPLERENOVATE"
              />{" "}
              WELCOME TO SIMPLERENOVATE!
            </span>
          </p>
          <h2>Select your Plan</h2>
          <p className="subtext">
            Choose the perfect plan to grow your innovative business and connect
            with quality clients.
          </p>
          <div className="toggle-buttons">
            <div className="toggle-button-2">
              <button
                className="toggle"
                style={{
                  background: active === 1 ? "" : "var(--gradient-red-50)",
                  color: active === 1 ? "" : "var(--white)",
                }}
                onClick={() => setActive(1)}
              >
                <img
                  src={active === 1 ? For_Professionals : For_Professionals1}
                  alt="For Professionals"
                  style={{
                    marginRight: "6px",
                  }}
                />
                For Professionals
              </button>
              {/* <button
                className="toggle inactive"
                style={{
                  background: active === 2 ? "" : "var(--gradient-red-50) ",
                  color: active === 2 ? "" : "var(--white)",
                }}
                onClick={() => setActive(2)}
              >
                <img
                  src={active === 1 ? For_Clients : For_Clients1}
                  alt="For Clients"
                  style={{
                    marginRight: "6px",
                  }}
                />
                For Clients
              </button> */}
              {/* {active === 2 && <p className="save_text">SAVE $439</p>} */}
            </div>
          </div>
        </div>

        <div className="plans">
          <Row>
            <Col md={12} lg={6} xl={4}>
              <div className="plan-card">
                {/* <div className="badge">Most Popular</div> */}
                <div className="plan-icon">
                  <img src={pricing_icon_profile} alt="pricing_icon_profile" />
                </div>
                <h3>Free Plan</h3>
                <div className="price">
                  $0<span>/month</span>
                </div>
                <p className="description">
                  Get started with basic features and purchase credits as you
                  go.
                </p>

                <ul className="features">
                  <h5>This includes:</h5>
                  <li>
                    <img src={Overlay_tick} alt="Overlay_tick" />
                    <div>
                      <span>
                       Start free and explore available jobs in your area
                      </span>
                    </div>
                  </li>
                  <li>
                    <img src={Overlay_tick} alt="Overlay_tick" />
                    <div>
                      <span>
                        Purchase additional credits as needed ($1/credit){" "}
                      </span>
                    </div>
                  </li>
                  <li>
                    <img src={Overlay_tick} alt="Overlay_tick" />
                    <div>
                      <span>Bid on any job using credits </span>
                    </div>
                  </li>
                  <li>
                    <img src={Overlay_tick} alt="Overlay_tick" />
                    <div>
                      <span>Standard profile visibility </span>
                    </div>
                  </li>
                  <li>
                    <img src={Overlay_tick} alt="Overlay_tick" />
                    <div>
                      <span>No client insights </span>
                    </div>
                  </li>
                </ul>

                <div className="card_footer">
                  <button
                    className="cta-button cta-button-gray"
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Professional" },
                      });
                    }}
                  >
                    Get Started Free
                  </button>
                  <p className="guarantee">No credit card required</p>
                </div>
              </div>
            </Col>

            <Col md={12} lg={6} xl={4}>
              <div className="plan-card">
                <div className="badge">Most Popular</div>
                <div className="plan-icon">
                  <img src={Plan} alt="Plan" />
                </div>
                <h3>Pro Plan</h3>
                <div className="price">
                  $149<span>/month</span>
                </div>
                <p className="description">
                  Everything you need to grow your innovative business and
                  connect with quality clients
                </p>

                <div className="pro-plan-card-padding">
                  <div className="pro-plan-card">
                    <div className="card-header">
                      <h2 className="plan-title">Monthly Pro Plan</h2>
                      {/* <span className="status-badge">
                        <img src={activeIcon} alt="active" /> Active
                      </span> */}
                    </div>

                    <div className="pricing">
                      <span className="price">$149</span>
                      <span className="period">/mo</span>
                    </div>

                    <div className="features-list">
                      {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                          <div
                            className="icon-wrapper"
                            style={{ backgroundColor: feature.color }}
                          >
                            {feature.icon}
                          </div>
                          <div className="feature-content">
                            <h3 className="feature-title">{feature.title}</h3>
                            <p className="feature-description">
                              {feature.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="card_footer">
                  <button
                    className="cta-button"
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Professional" },
                      });
                    }}
                  >
                    Start Monthly Plan - $149/mo
                  </button>
                  <p className="guarantee">No setup fee • Cancel anytime</p>
                </div>
              </div>
            </Col>

            <Col md={12} lg={6} xl={4}>
              <div className="plan-card plan-card-green">
                <div className="badge badge-green">Best Value</div>
                <div className="plan-icon">
                  <img src={Annual} alt="Annual" />
                </div>
                <h3>Pro Plan Annual</h3>
                <div className="price">
                  $1,349<span>/year</span>
                </div>
                <p className="description">
                  Save $439 annually — get 3 months free plus 300 bonus credits!
                </p>

                <div className="pro-plan-card-padding">
                  <div className="pro-plan-card">
                    <div className="features-list">
                      {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                          <div
                            className="icon-wrapper"
                            style={{ backgroundColor: feature.color }}
                          >
                            {feature.icon}
                          </div>
                          <div className="feature-content">
                            <h3 className="feature-title">{feature.title}</h3>
                            <p className="feature-description">
                              {feature.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="feature-content annual-bonus">
                      <h3 className="feature-title">Annual Plan Bonus:</h3>
                      <p className="feature-description">
                        Save $439 Annually (3 months free + 300 bonus credits)
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card_footer card_footer_green">
                  <button
                    className="cta-button cta-button-green"
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Professional" },
                      });
                    }}
                  >
                    Start Annual Plan - $1,349/yr``
                  </button>
                  <p className="guarantee">No setup fee • Cancel anytime</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="credits-system">
          {/* <div className="credits-system__header">
            <h1 className="credits-system__title">Credits System</h1>
            <p className="credits-system__subtitle">
              Use credits to bid on jobs and grow your business. Get 50 free
              credits when you sign up!
            </p>
          </div>

          <div className="credits-grid">
            <div className="card">
              <div className="card__header">
                <div className="card__icon card__icon--pink">
                  <img src={BiddingCosts} alt="BiddingCosts" />
                </div>
                <div>
                  <h2 className="card__title">Bidding Costs</h2>
                </div>
              </div>
              <p className="card__description">
                Credits required to bid on different job types
              </p>

              {biddingCosts.map((option, index) => (
                <div
                  key={index}
                  className={`bidding-option ${
                    index === 1 ? "premium-card" : ""
                  }`}
                >
                  <div>
                    <div className="bidding-option__name">{option.name}</div>
                    <div className="bidding-option__description">
                      {option.description}
                    </div>
                  </div>
                  <span className="bidding-option__badge">
                    {option.credits} credits
                  </span>
                </div>
              ))}
              <p className="note">
                Premium clients pay with credits to boost their job visibility
                and show they’re serious about getting their project done.
              </p>
            </div>

            <div className="card">
              <div className="card__header">
                <div className="card__icon card__icon--green">
                  <img src={Credit} alt="Credit" />
                </div>
                <div>
                  <h2 className="card__title">Credit Pricing</h2>
                </div>
              </div>
              <p className="card__description">Simple, transparent pricing</p>

              <div className="pricing-header">
                <div className="pricing-header__amount">$1.00</div>
                <div className="pricing-header__label">per credit</div>
              </div>

              <ul className="pricing-list">
                {pricingTiers.map((tier, index) => (
                  <li key={index} className="pricing-list__item">
                    <span className="pricing-list__label">
                      {tier.credits} credits
                    </span>
                    <span className="pricing-list__value">{tier.price}</span>
                  </li>
                ))}
              </ul>

              <p className="disclaimer">
                Custom amounts available (minimum 5 credits)
              </p>
            </div>
          </div>

          <div className="buy-button">
            <button
              className="btn"
              onClick={() => {
                handleViewDetails();
                navigate("/professional/login");
              }}
            >
              <img
                src={Buy_Credits}
                alt="Buy Credits"
                style={{ marginBottom: "4px", marginRight: "4px" }}
              />{" "}
              Buy Credits
            </button>
          </div> */}

          {/* <div className="rewards-section">
            <div className="rewards-header">
              <div className="rewards-header__icon">
                <img src={Earn} alt="Earn" />
              </div>
              <div className="rewards-header__content">
                <h3>Earn Free Credits</h3>
                <p>
                  Complete actions to add free credits and grow your business!
                </p>
              </div>
            </div>

            <div className="rewards-grid">
              <div>
                <h4 className="rewards-subtitle">
                  {" "}
                  <img
                    src={first_time_rewards}
                    alt="first_time_rewards"
                    style={{ marginRight: "4px" }}
                  />{" "}
                  First-Time Rewards
                </h4>
                {everFreeRewards.map((reward, index) => (
                  <div key={index} className="reward-item">
                    <span className="reward-item__name">{reward.name}</span>
                    <span className="reward-item__badge">
                      +{reward.credits} credits
                    </span>
                  </div>
                ))}
              </div>

              <div className="ongoing-rewards">
                <h4 className="rewards-subtitle">
                  {" "}
                  <img
                    src={ongoing_reward}
                    alt="ongoing reward"
                    style={{ marginRight: "8px" }}
                  />
                  Ongoing Rewards
                </h4>
                {ongoingRewards.map((reward, index) => (
                  <div key={index} className="reward-item">
                    <span className="reward-item__name">{reward.name}</span>
                    <span className="reward-item__badge">
                      +{reward.credits} credits
                    </span>
                  </div>
                ))}
                <div className="alert">
                  <div className="alert__title">Referral Bonus</div>
                  <div className="alert__content">
                    Both you and your referred contractor will get one month free access of pro plan when
                    they sign up and purchase the subscription. No limit on
                    referrals!
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="policy">
            <h3 className="policy__title">Credit Policy</h3>
            <ul className="policy__list">
              {policyItems.map((item, index) => (
                <li key={index} className="policy__item">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="benefits">
          <Row>
            <Col xs={12} sm={6} md={4}>
              <div className="benefit">
                <div className="icon">
                  <img src={VerifiedClients} alt="VerifiedClients" />
                </div>
                <h6>Verified Clients</h6>
                <p>ID-verified homeowners. No spam, no fake leads.</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <div className="benefit">
                <div className="icon">
                  <img src={GrowYourBusiness} alt="GrowYourBusiness" />
                </div>
                <h6>Grow Your Business</h6>
                <p>
                  Everything you need to grow and win more jobs, right from your
                  desk.
                </p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <div className="benefit">
                <div className="icon">
                  <img src={ExpertSupport} alt="ExpertSupport" />
                </div>
                <h6>Expert Support</h6>
                <p>Get help whenever you need it from our support team.</p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="footer">
          <h4>Questions about pricing?</h4>
          <p>
            Our team is here to help you choose the right plan for your
            business.
          </p>
          <button
            className="contact-button"
            onClick={() => {
              handleViewDetails();
              navigate("/contacts-us");
            }}
          >
            Contact Sales
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
